import ContactCard from "../../components/ContactCard/ContacCard"
import './ContactPage.css'

const ContactPage = () => {

    return (

        <div className='contact-page'>
            <ContactCard />
        </div>
    )
}

export default ContactPage
